import { trans } from "./trans";
import { buildBlurbEditor } from "./buildBlurbEditor";
import { notify } from "./notify";
import { request } from "./request";
import { humanDate } from "./humanDate";
import { scroll } from "./scroll";
import { playButton } from "./playButton";
import { cModal } from "./modal";
import { lang, languages, placeholder } from "../app";

export const initializeCreateButton = (blurbs, author, userLevel) => {
	$("#createBlurbButton")
		.off("click")
		.on("click", function (e) {
			e.preventDefault();
			buildBlurbEditor(blurbs, null, lang, author, userLevel);
			$(this).addClass("hidden");
		});
};
let pageNo = 1;
let perPage = 9;

export const presentBlurbs = (blurbs, author, userLevel, archive = false, urlId = null) => {
	if (urlId) {
		archive = true;
	}
	let admin = userLevel === "admin";
	if (!archive) {
		$("#cr_header span").text(trans("Corporate Responsibility"));
		$("#cr_list_wrapper").css("margin-top", "90px");
		$("#cr_hero, #cr_intro, #cr_factsheet_buttons, #community_links").removeClass("hidden");
		$("#asset_pagination, #showing_wrapper").addClass("hidden");
		if (admin || blurbs.length > 6) {
			$("#view_cr_archives_button")
				.removeClass("hidden")
				.off("click")
				.on("click", function () {
					scroll($("#cr_header"), 200);
					$("#view_cr_home_button").removeClass("hidden");
					$("#view_cr_archives_button").addClass("hidden");
					presentBlurbs(blurbs, author, userLevel, true);
				});
			// view archive button click handler
		}
	} else {
		// some structural updates if this is an archive view

		$("#cr_header span").text(trans("Corporate Responsibility Archives"));
		$("#cr_list_wrapper").css("margin-top", "0");
		$("#view_cr_archives_button, #cr_hero, #cr_intro, #cr_factsheet_buttons, #community_links").addClass("hidden");
		$("#asset_pagination, #showing_wrapper").removeClass("hidden");
		$("#view_cr_home_button")
			.off("click")
			.on("click", function () {
				scroll($("#cr_header"), 200);
				$("#view_cr_home_button").addClass("hidden");
				$("#view_cr_archive_button").removeClass("hidden");
				presentBlurbs(blurbs, author, userLevel, false);
			})
			.removeClass("hidden");
	}
	blurbs = blurbs.sort((a, b) => {
		if (a.langs[lang] && b.langs[lang]) {
			if (a.langs[lang].position < b.langs[lang].position) {
				return -1;
			} else if (a.langs[lang].position > b.langs[lang].position) {
				return 1;
			}
			return 0;
		} else {
			return 0;
		}
	});
	// sort blurbs of current lang by position property

	if (!admin) {
		let now = new Date().getTime();
		blurbs = blurbs.filter(item => item.langs[lang] && item.langs[lang].status && item.langs[lang].pubDate <= now);
	}
	// only active blurbs whose pubDate is before or equal
	// to right now should be viewable by non-admins

	perPage = archive ? 9 : 6;
	const blurbList = $("#cr_list_wrapper");
	let assetWrappers = blurbList.find(".asset_wrapper").addClass("hidden");
	// initially hide all asset wrappers;
	// we'll unhide them as their content is updated

	let blurbsInLang = blurbs.filter(item => item.langs[lang]);
	for (let i = 0; i < perPage; i++) {
		// here, i represents the index of wrappers in the dom

		let blurb = blurbsInLang[i + (pageNo - 1) * perPage];
		// map blurb index to current DOM positiion relative
		// to page No and perPage value

		if (blurb) {
			let wrapper = assetWrappers.eq(i).attr({
				id: blurb.id,
				"data-position": blurb.langs[lang].position
			});
			// assign wrapper and place id and
			// position data in DOM

			wrapper.find(".slideshow, .video, .play_button_overlay").remove();
			let desktopTarget = blurbList.find(`#desktop_target_${i}`);
			desktopTarget.find(".slideshow, .video, .play_button_overlay").remove();
			// remove any slideshows or videos left from
			// previous blurbs

			blurb = blurb.langs[lang];
			// id in hand, now we can replace blurb var
			// with its own langs property for convenience

			let imgWrapper = window.isMobile ? wrapper.find(".media_image_wrapper") : desktopTarget.find(".cr_blurb_image_wrapper");
			// mobile imgWrapper is main asset image wrapper;
			// desktop imgWrapper is target image wrapper

			if (blurb.video) {
				wrapper.find(".media_image_wrapper img").attr("data-src", blurb.video.thumb);
				imgWrapper.append(`<div data-embed='${blurb.video.embed}' class="video${window.isMobile ? " hidden" : ""} uk-height-1-1 uk-width-1-1 uk-flex uk-flex-middle uk-flex-center"></div>`);
				// hide video player for mobile;
				// we'll only show it when item is expanded

				wrapper.find(".media_image_wrapper").append(playButton());
			} else if (blurb.thumb && blurb.thumb.length) {
				wrapper.find(".media_image_wrapper img").attr("data-src", blurb.thumb[0].url ? blurb.thumb[0].url : placeholder);
				if (blurb.thumb.length === 1) {
					// single image; just place it in the .single img tag

					let imgsToUpdate = [imgWrapper.find(".single")];
					if (!window.isMobile) {
						imgsToUpdate.push(desktopTarget.find(".single"));
					}
					// mobile needs only imgWrapper updated; desktop needs
					// both initial img and target img updated

					imgsToUpdate.forEach(img => {
						img.attr("data-src", blurb.thumb[0].url).removeClass("hidden");
					});
				} else {
					// multiple images, so imgWrapper needs a slideshow

					if (!window.isMobile) {
						imgWrapper.find(".single").addClass("hidden");
					}
					// hide .single img tag in desktop imgWrapper

					imgWrapper.append(`<div class="slideshow${window.isMobile ? " hidden" : ""} uk-width-1-1 uk-height-1-1 uk-flex uk-flex-column uk-flex-center uk-slideshow" tabindex="-1" uk-slideshow></div>`);
					// hide .slideshow for mobile; we'll only show it when
					// item is expanded

					imgWrapper.find(".slideshow").append(`<ul class="uk-slideshow-items uk-width-1-1 uk-height-1-1">${blurb.thumb.map(img => `<li class="image uk-flex uk-flex-middle"><img uk-img data-src="${img.url}"/></li>`).join("")}</ul>
                         <div class="uk-flex uk-flex-center uk-position-small">
                            <ul class="uk-dotnav">
                                ${blurb.thumb.map((img, index) => `<li uk-slideshow-item="${index}"><a href="#">Item 1</a></li>`).join("")}
                            </ul>
                        </div>`);
				}
			} else {
				// no image or video; target gets placeholder
				wrapper.find(".media_image_wrapper img").attr("data-src", placeholder);
				desktopTarget.find(".cr_blurb_image_wrapper img").attr("data-src", placeholder);
			}
			// image(s), if any, placed in grid and desktop target;
			// otherwise, admins get a placeholder

			let date = humanDate(blurb.pubDate);
			wrapper.find(".pub_date_data").text(date);
			desktopTarget.find(".pub_date_data").text(date);
			// pubdate placed in grid and desktop target

			wrapper.find(".headline").text(blurb.headline);
			desktopTarget.find(".headline").text(blurb.headline);
			// headline placed in grid and desktop target

			wrapper.find(".item").html(blurb.item);
			desktopTarget.find(".item").html(blurb.item);
			// blurb copy placed in grid and desktop target

			if (admin) {
				// need edit/delete buttons and
				// item status indicator if they don't already exist

				wrapper.find(".edit_tools_wrapper").remove();
				wrapper.append(`<div class="edit_tools_wrapper uk-inline uk-margin-small-left uk-position-top-left">
                <span data-button class="blurbEdit_button" uk-icon="icon: pencil"></span><span data-button class="blurbDelete_button" uk-icon="icon: trash"></span><span><span data-status="${blurb.status}" class="${blurb.status ? "text-green" : "text-red"} pointer" uk-icon="icon: ${blurb.status ? "check" : "close"}; ratio: 1.2"></span> 
            </div>`);
			}

			wrapper.removeClass("hidden");
			// this wrapper is ready for viewing
		}
	}
	// blurbs are placed on the page along with
	// target divs for expanded blurb on button clicks

	if (admin) {
		let adminTools = $("#admin_tools")
			.html(
				`<div id="cr_editor_wrapper" class="uk-margin"></div>
            <div class="uk-flex">
                <button class="capitalize uk-button uk-button-primary" id="createBlurbButton">Create Item</button>
                <button class="capitalize uk-button uk-button-primary uk-margin-small-left" id="reorderButton">Reorder</button>
            </div>`
			)
			.removeClass("hidden");
		// add admin tools

		initializeCreateButton(blurbs, author, userLevel);

		let newPosHash = [];
		let origPosHash = blurbsInLang.map(blurb => blurb.langs[lang].position).join("");
		// for sorting;
		// this is concat of position values of blurbs
		// in this language

		$("#reorderButton").on("click", function (e) {
			e.preventDefault();
			$(this).attr("disabled", "true");
			// disable button until function is resolved

			if (!$("#reorder_wrapper").length) {
				adminTools.append(`<div id="reorder_wrapper" class="uk-section uk-section-muted uk-margin uk-width-1-1 uk-padding-small uk-position-relative">
                    <div class="uk-width-1-1 uk-margin">
                        <h3 class="capitalize uk-align-left">Reorder Panel</h3>
                        <div>
                            <span data-button id="reorderSaveButton" uk-icon="icon: check; ratio: 1.2" class="text-green hidden"></span>
                            <span data-button id="reorderCancelButton" uk-icon="icon: close; ratio: 1.2" class="text-red"></span>
                        </div>
                    </div>
                    <div id="reorder_list" uk-grid uk-sortable class="uk-width-1-1 uk-grid-small uk-child-width-1-1 uk-child-width-1-6@s"></div> 
                </div>`);
			}
			let reorderList = $("#reorder_list");
			blurbsInLang.forEach(blurb => {
				let _data = blurb.langs[lang];
				reorderList.append(`<div data-position="${_data.position}" data-id="${blurb.id}" class="reorder_item_wrapper">
                    <div class="reorder_item_image_wrapper uk-cover-container">
                        <img uk-cover uk-img data-src="${_data.thumb && _data.thumb.length && _data.thumb[0].url ? _data.thumb[0].url : _data.video ? _data.video.thumb : placeholder}"/>
                        ${_data.video ? playButton(48) : ""}
                    </div>
                    <div class="reorder_item_copy uk-margin-small-top">
                        ${_data.headline}<br/>
                        <span><em>Published ${humanDate(_data.pubDate)}</em></span>
                    </div>
                </div>`);
			});

			$("#reorderCancelButton").on("click", function () {
				$("#reorder_wrapper").remove();
				$("#reorderButton").removeAttr("disabled");
			});

			const reorderSaveButton = $("#reorderSaveButton").on("click", async function (e) {
				e.preventDefault();
				let _blurbs = [];
				$(".reorder_item_wrapper").each(function (index, _blurb) {
					_blurb = blurbs.find(blurb => blurb.id === $(this).attr("data-id"));
					_blurb.langs[lang].position = index + 1;
					_blurbs.push(_blurb);
				});
				_blurbs = _blurbs.map(blurb => {
					return {
						PutRequest: {
							Item: blurb
						}
					};
				});
				const pageSize = 25;
				function sendReq(params, index = 0) {
					return new Promise(async (resolve, reject) => {
						try {
							const response = await request(params, $("#reorder_wrapper"));
							if (index + pageSize < _blurbs.length) {
								index = index + pageSize;
								params.data = _blurbs.slice(index, index + pageSize);
								resolve(sendReq(params, index));
							} else {
								$("#blurb_editor").remove();
								presentBlurbs(blurbs, author, userLevel);
								resolve("New order saved");
							}
						} catch (err) {
							console.error(err);
							reject(err);
						}
					});
				}
				notify("Saving new order");
				try {
					const response = await sendReq({
						reqId: "4b9d14f5-1255-4f03-8b6a-da2363fe25ee",
						data: _blurbs.slice(0, pageSize)
					});
					notify(response, "success");
					origPosHash = newPosHash;
					$("#reorder_wrapper").remove();
					$("#reorderbutton").removeAttr("disabled");
					presentBlurbs(blurbs, author, userLevel, archive);
				} catch (err) {
					console.error(err);
					notify("There was an error", "danger");
				}
			});
			// saveOrderButton click handler

			reorderList.on("moved", function () {
				setTimeout(function () {
					newPosHash = [];
					reorderList.find("[data-position]").each(function () {
						newPosHash.push($(this).attr("data-position"));
					});
					newPosHash = newPosHash.join("");
					if (newPosHash === origPosHash) {
						// order is same as on page load

						reorderSaveButton.addClass("hidden");
					} else {
						reorderSaveButton.removeClass("hidden");
					}
				}, 100);
			});
			// make blurbs sortable for admins;
			// timeout needed to give DOM time to resolve
			// after element drag, apparently
		});
	}
	// handling for admin tools

	$(".cr_close_button")
		.off("click")
		.on("click", function (e) {
			e.preventDefault();
			initBlurbButtons();
		});
	// click handler for cr_close_button (this
	// is the closer on the desktop expanded body)

	const initBlurbButtons = () => {
		$(".video").html("");
		$(".target, .asset_wrapper .item").addClass("hidden");
		// restore hidden class to all .target (desktop)
		//  and .asset_wrapper .item elements (mobile)

		$(".play_button_overlay").removeClass("hidden");
		// restore any play button overlays

		if (window.isMobile) {
			let assetWrapper = $(".asset_wrapper");
			assetWrapper.find(".single").removeClass("hidden");
			assetWrapper.find(".slideshow, .video").addClass("hidden");
			assetWrapper.find(".media_image_wrapper").addClass("uk-cover-container").removeAttr("style").find("img").attr("uk-cover", "").removeAttr("style");
			// mobile views need to restore .single imgs and
			// hide .slideshow and .video elements
		}

		$(".pub_date_wrapper, .media_image_wrapper")
			.off("click")
			.on("click", function (e) {
				e.preventDefault();
				expandBlurb($(this));
			})
			.find(".cr_expand_button")
			.attr("uk-icon", "icon: plus; ratio: .65");
		// click reset to trigger expandBlurb
		// and icon is set to plus svg
	};
	// end initBlurbButtons fn

	const expandBlurb = button => {
		initBlurbButtons();
		// return all buttons to initial state

		let wrapper = button.parents(".asset_wrapper");
		let imageWrapper = wrapper.find(".media_image_wrapper");
		let pubDateButton = wrapper.find(`[target*='${window.isMobile ? "mobile" : "desktop"}']`);
		// targetButton is the correct pub date wrapper element

		let target = $(`#${pubDateButton.attr("target")}`).removeClass("hidden");
		// find target and unhide

		let slideshow = window.isMobile ? wrapper.find(".slideshow") : target.find(".slideshow");
		let video = window.isMobile ? wrapper.find(".video") : target.find(".video");

		if (slideshow.length) {
			// there is a slideshow that needs to be shown
			// and a .single image that needs to be hidden

			slideshow.removeClass("hidden");
			if (window.isMobile) {
				imageWrapper.height("auto").find(".single").addClass("hidden");
			} else {
				target.find(".single").addClass("hidden");
			}
		} else if (video.length) {
			// there is a video that needs to be shown
			// and a .single image that needs to be hidden

			video.append(video.attr("data-embed"));
			imageWrapper.find(".play_button_overlay").addClass("hidden");
			video.removeClass("hidden");
			if (window.isMobile) {
				imageWrapper.height("auto").find(".single").addClass("hidden");
			} else {
				target.find(".single").addClass("hidden");
			}
		} else {
			if (window.isMobile) {
				imageWrapper.height("auto").removeClass("uk-cover-container").find("img").removeClass("uk-cover").removeAttr("uk-cover").removeAttr("style");
			}
		}

		pubDateButton.off("click").on("click", function (e) {
			e.preventDefault();
			initBlurbButtons();
		});
		// update correct pub date wrapper to be a closer

		imageWrapper.off("click").on("click", function (e) {
			e.preventDefault();
			initBlurbButtons();
		});
		// update image wrapper to be a closer

		wrapper.find(".cr_expand_button").attr("uk-icon", "icon: minus; ratio: .65");
		// icon is set to minus svg

		scroll(window.isMobile ? wrapper : target, window.isMobile ? 90 : 200);
	};
	// end expandBlurb fn

	initBlurbButtons();
	// run to activate pub_date_wrapper click
	// handler

	if (admin) {
		$(".blurbEdit_button").on("click", function (e) {
			e.preventDefault();
			let id = $(this).parents(".asset_wrapper").attr("id");
			$("#createBlurbButton").addClass("hidden");
			buildBlurbEditor(
				blurbs,
				id,
				lang,
				author,
				userLevel,
				blurbs.find(item => item.id === id)
			);
		});
		// edit blurb click handler

		$(".blurbDelete_button").on("click", async function (e) {
			e.preventDefault();
			let id = $(this).parents(".asset_wrapper").attr("id");
			let delTarget = blurbs.find(blurb => blurb.id === id);
			try {
				await cModal(`<h4>Just checking ...</h4>
				<p>You are about to delete the ${languages[lang]}-language item <span class="bold">${delTarget.langs[lang].headline}</span>.</p><p class="bold">Is this the plan?</p>`);
				try {
					await request({
						reqId: "f7ace6c3-dc2b-47f4-9f08-b890a61739ea",
						id: id,
						datatype: "crItem"
					});
					blurbs = blurbs.filter(item => item.id != id);
					notify("Item successfully deleted", "success");
					presentBlurbs(blurbs, author, userLevel);
				} catch (err) {
					throw err;
				}
			} catch (err) {
				if (err) {
					console.error("Error deleting blurb", err);
					notify("There was an error deleting the blurb", "danger");
				}
			}
		});
		// delete blurb click handler

		$(".edit_tools_wrapper [data-status]").on("click", async function () {
			let toggle = $(this);
			let status = toggle.attr("data-status") === "true" ? true : false;
			let wrapper = toggle.parents(".asset_wrapper");
			let id = wrapper.attr("id");
			let blurb = blurbs.find(item => item.id === id);
			if ((!status && !blurb.langs[lang].headline) || !blurb.langs[lang].item || (!blurb.langs[lang].video && (!blurb.langs[lang].thumb || !blurb.langs[lang].thumb.length))) {
				// for status-to-true changes, don't allow
				// if minimum requirements aren't met: there's no headline OR
				// no item OR no thumb property or an empty thumb array
				notify(`<div style="text-align: left">Cannot make this item active in ${languages[lang]} because the minimum requirements aren't met. To be active, Corporate Responsibility items require:<br>- A headline<br/>- A body<br/>- At least one image OR a video</div>`, "danger", "top-right", 8000, "toggles", true);
			} else {
				blurb.langs[lang].status = !status;
				// status is flipped

				let params = {
					reqId: "4b9d14f5-1255-4f03-8b6a-da2363fe25ee",
					data: [
						{
							PutRequest: {
								Item: blurb
							}
						}
					]
				};
				try {
					notify("Updating database");
					const response = await request(params, wrapper.find(".media_image_wrapper"));
					notify("Update complete", "success");
					toggle
						.attr({
							"data-status": !status,
							"uk-icon": `icon: ${status ? "close" : "check"}; ratio: 1.2`
						})
						.removeClass(status ? "text-green" : "text-red")
						.addClass(status ? "text-red" : "text-green");
					// update blurb toggle button's attribute values
				} catch (err) {
					notify(`Error changing status: ${err}`, "danger");
				}
			}
		});
		// status toggle click handler
	}
	let numPages = Math.ceil(blurbsInLang.length / perPage);
	if (archive) {
		updatePagination(blurbsInLang, author, userLevel, archive, numPages);
	}
	// only archive page needs pagination

	if (urlId) {
		// someone wants to see a particular blurb expanded
		if (blurbsInLang.find(blurb => blurb.id === urlId)) {
			$(`.asset_wrapper[id='${urlId}'] .media_image_wrapper`).trigger("click");
		} else {
			if (pageNo < numPages) {
				pageNo++;
				presentBlurbs(blurbs, author, userLevel, true, urlId);
			}
		}
	}
};
// end presentBlurbs function

const updatePagination = (buildAssets, author, userLevel, archive, numPages) => {
	let paginationWrapper = $("#pagination_wrapper");
	let showingWrapper = $("#showing_wrapper");
	let pageList = paginationWrapper.find("ul").html("");
	if (pageNo > 1) {
		pageList.append(`<li>
                <a data-previous data-target="${pageNo - 1}"><span uk-pagination-previous></span></a>
            </li>`);
	}
	// we need a previous button if we're past page 1

	let isActive = pageNo === 1;
	pageList.append(`<li>
            <a data-target="1" class="page_link${isActive ? " uk-active" : ""}"><span class="page${isActive ? " active uk-flex uk-flex-center uk-flex-middle" : ""}">1</span></a>
        </li>`);
	// always have page 1

	if (numPages < 11) {
		// don't need our inactive elements
		for (let i = 2; i < numPages + 1; i++) {
			isActive = pageNo === i;
			pageList.append(`<li>
                    <a data-target="${i}" class="page_link${isActive ? " uk-active" : ""}"><span class="page${isActive ? " active uk-flex uk-flex-center uk-flex-middle" : ""}">${i}</span></a>
                </li>`);
		}
	} else {
		// need at least one inactive separator

		if (pageNo < 6) {
			// don't need beginning separator

			for (let i = 2; i < 9; i++) {
				isActive = pageNo === i;
				pageList.append(`<li>
                    <a data-target="${i}" class="page_link${isActive ? " uk-active" : ""}"><span class="page${isActive ? " active uk-flex uk-flex-center uk-flex-middle" : ""}">${i}</span></a>
                </li>`);
			}
			pageList.append(` <li class="uk-disabled"><span>...</span></li>
                <li>
                    <a data-target="${numPages}" class="page_link"${pageNo === numPages ? " uk-active" : ""}"><span class="page${pageNo === numPages ? " active uk-flex uk-flex-center uk-flex-middle" : ""}">${numPages}</span></a>
                </li>`);
		} else {
			// need at least beginning separator

			pageList.append(` <li class="uk-disabled"><span>...</span></li>`);
			let remaining = numPages - pageNo;
			let lastPage = remaining > 2 ? pageNo + 3 : numPages;
			for (let i = pageNo - 2; i < lastPage; i++) {
				isActive = pageNo === i;
				pageList.append(`<li>
                        <a data-target="${i}" class="page_link${isActive ? " uk-active" : ""}"><span class="page${isActive ? " active uk-flex uk-flex-center uk-flex-middle" : ""}">${i}</span></a>
                    </li>`);
			}
			if (pageNo < numPages - 3) {
				// need second separator
				pageList.append(` <li class="uk-disabled"><span>...</span></li>`);
			}
			pageList.append(`<li>
                    <a data-target="${numPages}" class="page_link${pageNo === numPages ? " uk-active" : ""}"><span class="page${pageNo === numPages ? " active uk-flex uk-flex-center uk-flex-middle" : ""}">${numPages}</span></a>
                </li>`);
		}
	}
	if (pageNo < numPages) {
		pageList.append(`<li>
                <a data-next data-target="${pageNo + 1}"><span uk-pagination-next></span></a>
            </li>`);
	}
	// we need a next button if we're not on last page

	let startPage = buildAssets.length ? pageNo * perPage - perPage + 1 : 0;
	let endPage = pageNo * perPage > buildAssets.length ? buildAssets.length : pageNo * perPage;
	// calculate last page in showing range

	showingWrapper.html(`<span>${trans.showing ? trans.showing : "Showing"}</span> ${startPage}-${endPage} ${trans.of ? trans.of : "of"} ${buildAssets.length}`);

	$("#pagination_wrapper [data-target]")
		.off("click")
		.on("click", function () {
			pageNo = parseInt($(this).attr("data-target"));
			presentBlurbs(buildAssets, author, userLevel, archive);
			scroll($("#showing_wrapper"), 100);
			updatePagination(buildAssets, author, userLevel, archive, numPages);
		});
	// click handler for pagination
};
// end updatePagination function
